(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky header: hides on scroll-down, returns on scroll-up, and flags the
     "scrolled" state that fades the cream surface in. Same contract as Dawn's
     (classes on .section-header) so base.css keeps doing the positioning. */

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
      this.headerBounds = {};

      this.measure();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.measure.bind(this));

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = () => this.measure();
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
    }

    /* Document-relative bounds, measured directly. Dawn read these from an
       IntersectionObserver's intersectionRect, which is viewport-relative and
       was then compared against a document-relative scrollTop. That is correct
       only while the page happens to be at scroll 0. */
    measure() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // While flown, the header's box is no longer where the page rests, so
      // there is nothing trustworthy to measure. The resting bounds still hold.
      if (this.header.classList.contains('shopify-section-header-sticky')) return;
      const rect = this.header.getBoundingClientRect();
      const top = rect.top + window.scrollY;
      this.headerBounds = { top: top, bottom: top + rect.height };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onScroll() {
      // While the mobile nav drawer is open it pins the header itself
      // (menu-open on .section-header) and freezes the page underneath via
      // overflow-hidden on <body>. Reacting to scroll here while that's
      // active — including a synthetic scroll event some browsers fire when
      // overflow-hidden removes the scrollbar — can strip
      // shopify-section-header-sticky via reset() and drop the header out of
      // position: sticky entirely, leaving it wherever it sits in normal
      // flow (i.e. nowhere near the viewport on a long page). So: no-op
      // while the drawer has it pinned.
      if (this.header.classList.contains('menu-open')) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      // Never drop sticky positioning while the drawer has the header pinned
      // open (menu-open) — see the guard in onScroll() for why.
      if (this.header.classList.contains('menu-open')) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Desktop shop menu. Opening and closing the panel is pure CSS
     (:hover / :focus-within on the nav item); this handles what CSS cannot:
     which cards are shown, replaying their entrance, and what the button says.

     Cards are re-animated by removing the class, forcing a reflow, and adding
     it back — without the reflow the browser coalesces both changes into no
     change at all and the animation never replays. */
  (function () {
    var panel = document.querySelector('[data-shop-menu]');
    if (!panel) return;

    var item = panel.closest('.orquis-hd__nav-item--mega');
    var pills = Array.prototype.slice.call(panel.querySelectorAll('.orquis-hd__mega-cat'));
    var cards = Array.prototype.slice.call(panel.querySelectorAll('.orquis-hd__mega-item'));
    var button = panel.querySelector('[data-shop-menu-cta]');
    var buttonBase = button ? button.dataset.labelBase || 'Shop' : 'Shop';
    /* No early return on an empty pill list: with the tab row gone the rail
       still needs its arrow measuring below. The pill wiring further down is a
       no-op over an empty array, and the footer CTA keeps the label and href
       Liquid rendered for it. */

    /* The arrows are only controls while the rail can actually scroll. Measured
       rather than counted: the rail fits five cards, but that is a CSS figure,
       and a count in here would go stale the moment the CSS changes. */
    var rail = panel.querySelector('.orquis-rail--menu');
    var grid = panel.querySelector('[data-shop-menu-grid]');
    function syncArrows() {
      if (!rail || !grid) return;
      rail.classList.toggle('is-static', grid.scrollWidth <= grid.clientWidth + 2);
    }
    syncArrows();
    window.addEventListener('resize', syncArrows);

    var current = null;

    function play(visible) {
      visible.forEach(function (card, index) {
        card.classList.remove('is-entering');
        card.style.setProperty('--i', index);
      });
      // one reflow for the whole set, not one per card
      void panel.offsetWidth;
      visible.forEach(function (card) {
        card.classList.add('is-entering');
      });
    }

    /* `animate` is off when the swap is not the thing the eye is on — the
       reset back to "all" happens after the panel has finished closing, and
       replaying an entrance there is what made the cards flash. */
    function show(type, label, animate) {
      if (type === current) return;
      current = type;

      pills.forEach(function (p) {
        var on = (p.dataset.type || '') === type;
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
        /* The button follows the active category in BOTH respects. Its label was
           being rewritten to "Shop featured" while its href still pointed at the
           whole catalogue, so every category landed on the unfiltered shop page.
           The destination comes from the pill's own data-url, which is rendered
           from the same routes the shop page's pills use. */
        if (on && button && p.dataset.url) button.setAttribute('href', p.dataset.url);
      });

      var visible = [];
      cards.forEach(function (card) {
        /* `__featured` is the one tab that is not a product type: it is the
           featured collection (tag = new), matched on its own data attribute. */
        var match = type === '__featured'
          ? card.dataset.featured === 'true'
          : card.dataset.type === type;
        var hide = type !== '' && !match;
        card.hidden = hide;
        if (!hide) visible.push(card);
      });

      /* Back to the first card. The rail keeps its scroll position across a
         filter change, so switching category while scrolled right opened onto
         a half-cut card or an empty stretch. Instant, not smooth: the CSS sets
         scroll-behavior, and a rail gliding sideways underneath the cards'
         entrance was the other half of what read as broken. */
      if (grid) grid.scrollTo({ left: 0, behavior: 'instant' });

      syncArrows();

      if (animate) play(visible);

      if (button) button.textContent = buttonBase + ' ' + label;
    }

    pills.forEach(function (pill) {
      var type = pill.dataset.type || '';
      var label = (pill.textContent || '').trim();
      pill.addEventListener('mouseenter', function () { show(type, label, true); });
      pill.addEventListener('focus', function () { show(type, label, true); });
      pill.addEventListener('click', function (event) { event.preventDefault(); show(type, label, true); });
    });

    if (item) {
      /* Hover on the trigger opens it; only leaving the header closes it. The
         nav item's own :hover cannot hold the panel open once the pointer
         moves sideways onto the logo or the cart, so an explicit open state
         takes over and the whole header — panel included, since the panel is a
         descendant of it — becomes the region you have to leave. */
      var head = item.closest('.orquis-hd');
      var CLOSE_MS = 720; // matches the panel's clip-path transition
      var resetTimer = null;

      /* No entrance on open. The unroll is already revealing the cards, and a
         second animation firing underneath it read as a flash rather than as
         an arrival. Cards fly in for category changes only, which is the one
         case where the panel is still and the contents are what moved. */
      function open() {
        window.clearTimeout(resetTimer);
        item.classList.remove('is-closing');
        item.classList.add('is-open');
      }

      /* `is-closing` is what holds the header grey and square-cornered for as
         long as the panel is still on its way up. The filter resets only once
         the panel is gone, so nothing visibly changes mid-close. */
      function close() {
        if (!item.classList.contains('is-open')) return;
        item.classList.remove('is-open');
        item.classList.add('is-closing');
        window.clearTimeout(resetTimer);
        resetTimer = window.setTimeout(function () {
          item.classList.remove('is-closing');
          show('', (pills[0].textContent || 'all').trim(), false);
        }, CLOSE_MS);
      }

      item.addEventListener('mouseenter', open);

      if (head) {
        head.addEventListener('mouseleave', close);
      } else {
        item.addEventListener('mouseleave', close);
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Sticky "add to bag" bar: shows once the real buy button has scrolled off.

     The bar's button carries `form="product-form-<section>"`, so clicking it
     submits Dawn's own form and product-form.js intercepts it exactly as it
     does the in-page button — AJAX add, cart drawer opens. Nothing here
     duplicates the commerce path, and the bar carries no price, because
     Dawn's variant re-render only refreshes a hardcoded list of ids and a
     second price node would silently go stale on a shade change. */
  (function () {
    document.querySelectorAll('.orquis-atc-bar').forEach(function (bar) {
      var anchor = document.getElementById(bar.dataset.watch);
      if (!anchor) return;

      if (!('IntersectionObserver' in window)) {
        bar.hidden = false;
        return;
      }

      bar.hidden = false;
      new IntersectionObserver(
        function (entries) {
          // Only once the anchor has left upward: the bar must not cover the
          // buy button while it is still on screen further down the page.
          var e = entries[0];
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      ).observe(anchor);

      /* Shade dots drive the real radios in the picker rather than holding any
         state of their own. product-info.js replaces the whole
         <variant-selects> on every change, so the radios are looked up at click
         time and never cached, and the dots re-sync from whichever radio ends up
         checked — however the shade was changed. */
      var shades = bar.querySelectorAll('.orquis-atc-bar__shade');
      if (shades.length) {
        var syncShades = function () {
          var checked = document.querySelector('.orquis-shade__input:checked');
          if (!checked) return;
          shades.forEach(function (dot) {
            dot.classList.toggle('is-active', dot.dataset.shade === checked.value);
          });
        };

        shades.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var radios = document.querySelectorAll('.orquis-shade__input');
            for (var i = 0; i < radios.length; i++) {
              if (radios[i].value === dot.dataset.shade) {
                radios[i].click();
                break;
              }
            }
            shades.forEach(function (d) { d.classList.toggle('is-active', d === dot); });
          });
        });

        document.addEventListener('change', function (event) {
          if (event.target.classList && event.target.classList.contains('orquis-shade__input')) syncShades();
        });
      }

      /* And it steps aside at the end of the page. Sitting over the footer it
         covers the newsletter field and the policy links, and there is nothing
         left to scroll back to. */
      var footer = document.querySelector('.shopify-section-group-footer-group');
      if (footer) {
        /* Read on scroll rather than through an observer: a fixed bar sitting
           over the element being observed made the intersection unreliable on
           phones, and the bar stayed put over the footer. This asks the same
           question — has the footer reached the bottom of the screen — but
           asks it directly. */
        var ticking = false;
        var checkEnd = function () {
          ticking = false;
          bar.classList.toggle('is-at-end', footer.getBoundingClientRect().top <= window.innerHeight);
        };
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(checkEnd);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        checkEnd();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
